import React from "react";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import Query from "react-apollo/Query";

import {GET_USER_KYC} from "../../../queries";
import KYC_inner from "./KYC_inner";

class KYC_main extends React.Component{
    constructor(props){
        super(props);
    }
    
    render(){        
        return (
            <Query query={GET_USER_KYC} variables={{ email: this.props.session.email }}>
                {({ data, loading, error}) => {
                    if (loading) return <div>loading</div>;
                    if (error) return <div>error</div>;

                    return <KYC_inner session={this.props.session} userKYC={data.getUserKYC}/>;
                }}
            </Query>
        )
    }
}

export default withAuth(session => session && session)(withRouter(KYC_main));
